import React from 'react';
import { View } from 'react-native';

// Web shim for react-native-linear-gradient using CSS gradients
export default function LinearGradient({ colors = [], start, end, locations, angle, style, children, ...props }) {
  const gradientColors = colors.join(', ');
  const gradientStyle = {
    backgroundImage: `linear-gradient(${angle != null ? `${angle}deg` : 'to bottom'}, ${gradientColors})`,
  };

  return (
    <View style={[style, gradientStyle]} {...props}>
      {children}
    </View>
  );
}
